



































import AttachmentsUpload from "@/components/AttachmentsUpload.vue";

export default {
  components: { AttachmentsUpload },
  props: {
    value: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    return {
      update: (updated) => emit("input", { ...props.value, ...updated }),
    };
  },
};
